import Vue from 'vue'
import axios from 'axios'
let baseURL = 'https://product.rakumart.com'
let token = localStorage.getItem('token')
import qs from 'qs'

// 授权登入
export const authLogin = (data) => axios({
    url: baseURL + '/api/open/v1/oauth/authLogin',
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})